import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import React, { Component } from "react";
import { Prompt } from "react-router";
import Button from "../../../../../FormElement/Button";
import InputFiled from "../../../../../FormElement/InputFiled";


const signInSectionStyle = {
  display: "flex",
  alignItems: "baseline",
  justifyContent: "space-between"
};

class LoadIndicatorForm extends Component {
  state = {};
  render() {
    const {
      loadInfo,
      createLoadIndicator,
      buttonLabel,
      formLabel,
      isValid,
      handleChange,
      handleError,
      onCancel,
      edited
    } = this.props;
    return (
      <div className="">
        <Prompt when={edited} message="Changes you made may not be saved." />
        <div className="textRequired">* Required Cells</div>
        <div className="innermainform">
          <p className="loginHeader">{formLabel}</p>
          <Grid container spacing={8}>
            <Grid item xs={12}>
              <InputFiled
                label="Load Number Indicator Type"
                value={loadInfo.type}
                required
                validations={["required", "maxSize"]}
                handleError={handleError}
                handleChange={handleChange}
                type="text"
                name="type"
              />
            </Grid>
            <Grid item xs={12}>
              <InputFiled
                label="Load Number Indicator Code"
                value={loadInfo.code}
                required
                validations={["required", "maxSize"]}
                handleError={handleError}
                handleChange={handleChange}
                type="text"
                name="code"
              />
            </Grid>
          </Grid>
          <div className="signInSection" style={signInSectionStyle}>
            <Link
              className="cancelButton"
              component="button"
              onClick={onCancel}
            >
              Cancel
            </Link>
            <Button
              name={buttonLabel}
              disabled={isValid}
              onclick={createLoadIndicator}
              styleClass="signIn"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default LoadIndicatorForm;



// WEBPACK FOOTER //
// ./src/components/private/FarmInformation/parts/FieldGroups/LoadNumberIndicators/LoadIndicatorForm.js